import { useQuery } from 'react-query'

import { useAxiosContext } from '@dc-shared-web/providers/AxiosProvider'
import { fetchProvisionHighlights } from '@dc-shared-web/hooks/api/annotations/fetchProvisionHighlights'

import { ProvisionHighlight } from '@dc-shared-web/hooks/api/annotations/types'

type GetProvisionHighlightsParams = {
  crunchUUID?: string
  includeDeleted?: boolean
  enabled?: boolean
}

export const useGetProvisionHighlights = (
  params: GetProvisionHighlightsParams
) => {
  const apiClient = useAxiosContext()

  return useQuery<ProvisionHighlight[], Error>(
    params.includeDeleted
      ? ['highlights', params.crunchUUID, 'deleted']
      : ['highlights', params.crunchUUID],
    () => fetchProvisionHighlights(apiClient, params),
    {
      enabled: !!params.crunchUUID && params.enabled !== false,
    }
  )
}
